import MessageBox from './MessageBox';
import React from 'react';
import { SUPPORT_MESSAGE } from '../../shared/constants';

const EmailUpdateFail = () => {
  return (
    <MessageBox
      header="Whoops!"
      message="Email update has failed."
      secondaryMessage={SUPPORT_MESSAGE}
    />
  );
};

export default EmailUpdateFail;
